import {css} from "lit";

export const linkOnDarkStyles = css`
    --_link-border-focus: var(--sbkLinkBorderOnDarkFocus);
    --_link-color: var(--sbkLinkFgColorOnDarkEnabled);
    --_link-color-hover: var(--sbkLinkFgColorOnDarkHover);
    --_link-color-active: var(--sbkLinkFgColorOnDarkActive);
    --_link-color-disabled: var(--sbkLinkFgColorOnDarkDisabled);
    --_link-color-visited: var(--sbkLinkFgColorOnDarkVisited);
    --link-color-selected: var(var(--sbkLinkFgColorOnDarkSelected));
`;
